module.exports = __webpack_public_path__ + "img/illu-step2.78f208a5.svg";